import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Tupoksi from '@/views/Tupoksi.vue'
import Struktur from '@/views/Struktur.vue'
import Visi from '@/views/Visi.vue'
import Berita from '@/views/Berita.vue'
import DetailBerita from '@/views/DetailBerita.vue'
import Pengumuman from '@/views/Pengumuman.vue'
import Dokumen from '@/views/Dokumen.vue'
import Foto from '@/views/Foto.vue'
import Video from '@/views/Video.vue'
import Sekretariat from '@/views/Sekretariat.vue'
import Pejabat from '@/views/Pejabat.vue'
import Sosial from '@/views/Sosial.vue'
import Kaban from '@/views/Kaban.vue'
import Ekonomi from '@/views/Ekonomi.vue'
import Inovasi from '@/views/Inovasi.vue'
import Peraturan from '@/views/Peraturan.vue'
import Sop from '@/views/Sop.vue'
import Uptd from '@/views/Uptd.vue'
import Fungsional from '@/views/Fungsional.vue'
import Penelitian from '@/views/Penelitian.vue'
import Artikel from '@/views/Artikel.vue'
import Jurnal from '@/views/Jurnal.vue'
import Inovda from '@/views/Inovda.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/tupoksi',
    name: 'tupoksi',
    component: Tupoksi
  },
  {
    path: '/struktur',
    name: 'struktur',
    component: Struktur
  },
  {
    path: '/visi',
    name: 'visi',
    component: Visi
  },
  {
    path: '/pejabat',
    name: 'pejabat',
    component: Pejabat
  },
  {
    path: '/kaban',
    name: 'kaban',
    component: Kaban
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: Sekretariat
  },
  {
    path: '/sosial',
    name: 'sosial',
    component: Sosial
  },
  {
    path: '/ekonomi',
    name: 'ekonomi',
    component: Ekonomi
  },
  {
    path: '/inovasi',
    name: 'inovasi',
    component: Inovasi
  },
  {
    path: '/uptd',
    name: 'uptd',
    component: Uptd
  },
  {
    path: '/fungsional',
    name: 'fungsional',
    component: Fungsional
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita
  },
  {
    path: '/detail_berita',
    name: 'detail_berita',
    component: DetailBerita
  },
  {
    path: '/pengumuman',
    name: 'pengumuman',
    component: Pengumuman
  },
  {
    path: '/sop',
    name: 'sop',
    component: Sop
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: Dokumen
  },
  {
    path: '/peraturan',
    name: 'peraturan',
    component: Peraturan
  },
  {
    path: '/penelitian',
    name: 'penelitian',
    component: Penelitian
  },
  {
    path: '/artikel',
    name: 'artikel',
    component: Artikel
  },
  {
    path: '/jurnal',
    name: 'jurnal',
    component: Jurnal
  },
  {
    path: '/inovda',
    name: 'inovda',
    component: Inovda
  },
  {
    path: '/foto',
    name: 'foto',
    component: Foto
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
